import React from 'react';

import { inject } from 'mobx-react';
import { MuiThemeProvider } from '@material-ui/core/styles';

import Section from '../sections';

import {themes} from '../utils/themes';

import { Head } from '../components/shared';

const mapper = () => ({})

class Routes extends React.Component {
    render() {        
        return (
            <MuiThemeProvider theme={themes['main']}>
                <Head />
                <Section />
            </MuiThemeProvider>
        );
    }
}

export default inject(mapper)(Routes);
